import React from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_OPTIONS } from "graphql/query/email-gql";
import { GET_SUMMARY_STATISTIC } from "graphql/query/statistic-gql";
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import SettingRoute from 'components/routes/settings/setting-route';
import { Localize } from "components/service";



const SettingsPage = ({ history }) => {

    useActiveMenuItem([ "settings" ], [ "settings" ]);


    const { pathname } = useLocation();
    const isEmailRules = pathname.replace(/\/$/, "") === "/settings/email-rules";
    const isCounters = pathname.replace(/\/$/, "") === "/settings/counters";
    const { data: { options } = {}, loading: loadingQueryOptions } = useQuery(GET_OPTIONS, { skip: !isEmailRules });
    const { data: { summaryStatistic } = {}, loading: loadingQueryStatistics } = useQuery(GET_SUMMARY_STATISTIC, { skip: !isCounters });

    const pageNavbar = [
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_App" }).props.children,
            path: ""
        },
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_EmailRules" }).props.children,
            path: "email-rules"
        },
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_Counters" }).props.children,
            path: "counters"
        }
    ];


    const loading = loadingQueryOptions || loadingQueryStatistics;


    return (
        <PageWrapDefault
            className="page-settings"
            dataExist={ !loading }
            loading={ loading }
            title={ <Localize>PAGES.Title_Settings</Localize> }
            pageNavbar={ pageNavbar }
            staticPath={ `/settings` }
        >
            <SettingRoute history={ history } options={ options } summaryStatistic={ summaryStatistic } />

        </PageWrapDefault>
    );
};

export default SettingsPage;
